module.exports = __webpack_public_path__ + "static/img/landing-step-3.7dee47f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/landing-step-3.svg
// module id = +fmx
// module chunks = 1